import axios from "../http";

class AddServiceManage {
  // 增值服务列表
  static getAddServiceList(params = {}) {
    const url = `/zwy/api/cb/logistics/project/service/fee/type/list`;
    return axios.get(url, { params }).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 新增增值服务
  static postAddAddService(data) {
    const url = `/zwy/api/cb/logistics/project/save/service/fee`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑增值服务
  static postUpdateAddService(id, data) {
    const url = `/zwy/api/cb/logistics/project/update/service/fee/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 开启/关闭增值服务
  static postUpdateAddServiceStatus(id, data) {
    const url = `/zwy/api/cb/logistics/project/update/status/service/fee/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default AddServiceManage;
